import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import Header from "../HeaderNew/component";
import "./styles.scss";
import {
  ondcSelect,
  ondcInit,
  ondcConfirm,
} from "../../slices/ondcPreorderSlice";
import { useSelector, useDispatch } from "react-redux";
import { get } from "lodash";
import { Modal, ModalBody } from "reactstrap";
import { EditIcon, MinusIcon, PlusIcon } from "../../components/svgicons";
import API from "../../api/indexv2";
import {
  handleError,
  errorCodeMessages,
  notify,
  handleAddToCart,
  handleCheckout,
  handlePurchase,
} from "../../components/common/utils";
import { GET_USER_ADDRESS } from "../../api/apiList";
import { updateCartItem } from "../../slices/catalogSlice";
import { USER_DATA } from "../../components/common/constant";
import Loader from "../../components/common/loader";
import debounce from "lodash/debounce";
import WrappedMap from "../../components/Map/map";
import store from "../../store";
import { getLocations, saveSearchHistory, startLoadingMap } from "../../slices/mapSlice";
import EmptyCart from "../../images/cart.png";
import RightIcon from "../../images/ProductImg/success-right.svg";
import PreRazorpay from "../Razorpay/PreRazorpay";
import ThankYouModal from "../../components/common/ThankyouModal";
import {
  getPlacesDetails,
  placeDetail,
  handleAddress,
} from "../../api/ApiService";
import searchIcon from "../../images/searchIcon.svg";
import { ToastContainer } from "react-toastify";
import { Helmet } from "react-helmet";
import AvailOfferIcon from "../../images/avail-coupon-icon.svg";
import OfferRight from "../../images/home/right-arrow.svg";
import bottomArrowCoupon from "../../images/bottom-arrow-coupon.svg";
import AppliedCoupon from "../../images/applied-coupon.svg";
import { fetchCoupon, searchCoupon } from "../../slices/couponSlice";
import axios from "axios";
import ArrowBack from "../../images/home/arrow_back.svg";
import CurrentLocationIcon from "../../images/home/current-location-icon.svg";
import LocationPinIcon from "../../images/home/location-pin-icon.svg";
import blacksearchIcon from "../../images/home/location-pin-green.svg";
import LoaderWhite from "../../components/common/LoaderWhite";

const Checkout = () => {
  const dispatch = useDispatch();
  const [error, setError] = useState("");
  const [isNewBillingAddress, setIsNewBillingAddress] = useState(false);
  const navigate = useNavigate();
  let cartItems = JSON.parse(localStorage.getItem("cart"));
  const defaultAddress = JSON.parse(localStorage.getItem("defaultAddress"));
  const user = JSON.parse(localStorage.getItem("user"));
  const ondcCartDataLocal = JSON.parse(localStorage.getItem("ondcCart"));
  const [cartItemsTemp, setCartItemsTemp] = useState(cartItems);
  const [ondcCartData, setOndcCartData] = useState(ondcCartDataLocal);
  const [loading, setLoading] = useState(false);
  const [openRazorpay, setOpenRazorpay] = useState(false);
  const [payableAmount, setPayableAmount] = useState(0);
  const [orderDetails, setOrderDetails] = useState({});
  const [editAddress, setEditAddress] = useState({});
  const [getCurrentLocationLoader, setGetCurrentLocationLoader] = useState(false);
  const [userAddress, setUserAddress] = useState([]);
  const [map, setMap] = useState(false);
  const [tempAddress, setTempAddress] = useState({});
  const [openFromEdit, setOpenFromEdit] = useState(false);
  const [loadingAddAddress, setLoadingAddAddress] = useState(false);
  const [building, setBuilding] = useState("");
  const hiddenCloseRef = useRef();
  const getUserFromLocalStorage = () => {
    try {
      return JSON.parse(localStorage.getItem(USER_DATA) || "");
    } catch (error) {
      return null;
    }
  };
  const userData = getUserFromLocalStorage();
  const [emailId, setEmailId] = useState(userData ? userData.email : "");
  const [buyerName, setBuyerName] = useState(userData ? userData.name : "");
  const [searchmodal, setSearchModal] = useState(false);
  const [showAddressEdit, setShowAddressEdit] = useState(false);
  const [buyerNumber, setBuyerNumber] = useState(userData ? userData.mobile : "");
  const [openThankPopup, setOpenThankPopup] = useState(false);
  const [openErrorModal, setOpenErrorModal] = useState(false);
  const [errorModalError, setErrorModalError] = useState(null);
  const [shippingAddress, setShippingAddress] = useState(defaultAddress?.address);
  const [billingAddress, setBillingAddress] = useState(shippingAddress);
  const [accordionSteps, setAccordionSteps] = useState([
    { id: 1, title: "Cart", completed: false },
  ]);
  const [openDropdownId, setOpenDropdownId] = useState(null);
  const ondcIsCartError = useSelector((s) => s.ondcPreorder.ondcIsCartError);
  const ondcConfirmstatus = useSelector(
    (s) => s.ondcPreorder.ondcConfirmstatus
  );
  const locations = useSelector((s) => s.mapApi.locations);
  const loadingMapAddress = useSelector((s) => s.mapApi.startLoadingMap);
  const address = useSelector((s) => s.mapApi.address);
  const ondcInitstatus = useSelector((s) => s.ondcPreorder.ondcInitstatus);
  const [ondcOrderId, setOndcOrderId] = useState("");
  const [deliveryType, setDeliveryType] = useState("");
  const [deliveryTypeFulfillmentId, setDeliveryTypeFulfillmentId] = useState("");
  const [selectedCoupon, setSelectedCoupon] = useState(null);
  const [selectedTC, setSelectedTC] = useState(null);
  const [finalAmount, setFinalAmount] = useState(0);
  const coupons = useSelector((s) => s.coupon?.coupon || []);
  const couponStatus = useSelector((s) => s.coupon?.status);
  const [couponInput, setCouponInput] = useState("");
  const searchCouponStatus = useSelector((s) => s.coupon?.searchCouponStatus);
  const landingSource = localStorage.getItem("landingSource");
  const [activeTab, setActiveTab] = useState("tabs-1"); // Initialize activeTab state
  const recentSearches = useSelector((s) => s.mapApi.searchHistory);
  const [applyCouponError, setApplyCouponError] = useState("");

  const selectAddressLoader = useSelector(
    (s) => s.mapApi.selectAddressMapLoading
  );

  const calculateDiscount = (coupon) => {

    if (!coupon) return 0;
    const baseAmount = totalItemAmount + totalOtherChargesAmount;
    if (coupon?.discountType === "percentage") {
      return Math.min(
        (parseFloat(coupon?.couponDiscount) / 100) * baseAmount,
        coupon?.maximumDiscountAmount || 0
      );
    } else {
      return parseFloat(coupon?.couponDiscount) || 0;
    }
  };

  useEffect(() => {
    if (coupons?.length > 0) {
      const nonQCCoupons = landingSource !== `${process.env.REACT_APP_LANDING_SOURCE}` ? coupons.filter((coupon) => coupon?.isForQC !== true) : coupons;
      const validCoupons = nonQCCoupons.filter(
        (coupon) =>
          finalAmount >= coupon?.minimumOrderValue &&
          finalAmount <= coupon?.maximumOrderValue &&
          coupon?.status &&
          coupon?.isActive
      );
      if (validCoupons.length > 0) {
        const bestCoupon = validCoupons.reduce((maxCoupon, currentCoupon) => {
          const maxDiscount = calculateDiscount(maxCoupon);
          const currentDiscount = calculateDiscount(currentCoupon);
          return currentDiscount > maxDiscount ? currentCoupon : maxCoupon;
        });
        setSelectedCoupon(bestCoupon);
      }
    }
  }, [coupons]);

  useEffect(() => {
    if (user) {
      dispatch(
        fetchCoupon({
          userId: user?._id,
          providerId: cartItems?.[0]?.catalogData?.providerId,
          landingSource: localStorage.getItem("landingSource") ? localStorage.getItem("landingSource") : ""
        })
      );
    }
  }, []);

  useEffect(() => {
    setTempAddress({ ...address, tag: "HOME" });
    setEditAddress({
      ...editAddress,
      ...address,
      tag: "HOME",
      region: {
        latitude: address?.latitude,
        longitude: address?.longitude,
      },
    });
    if (address?.latitude && searchmodal) {
      setMap(true);
      setSearchModal(false);
    }
  }, [address]);

  useEffect(() => {
    updateStepCompletion(1, true);
    fetchAddress();
  }, []);

  useEffect(() => {
    const deliveryTypeObj = ondcCartData?.message?.order?.fulfillments?.find(
      (item) => item.type === "Delivery"
    );
    if (deliveryTypeObj && !deliveryType) {
      setDeliveryTypeFulfillmentId(deliveryTypeObj?.id);
      setDeliveryType(deliveryTypeObj.type);
      calculateTotalItemAmount(ondcCartData, deliveryTypeObj?.id);
    }
  }, [ondcCartData]);

  const checkValidation = (value) => {
    if (!value || value === undefined || value == null || value === "") {
      return false;
    } else {
      return true;
    }
  };

  const checkEmailPhoneValidation = (type, value) => {
    if (type === "email") {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return emailRegex.test(value);
    } else if (type === "phone") {
      const phoneRegex = /^\d{10}$/;
      return phoneRegex.test(value);
    } else {
      return true;
    }
  };

  const dispatchOndcSelect = (updatedCartItems) => {
    setLoading(true);
    const defaultAddress = JSON.parse(localStorage.getItem("defaultAddress"));
    const select_transaction_id = JSON.parse(
      localStorage.getItem("transaction_id")
    );
    const items = updatedCartItems?.map((item) => ({
      id: item.catalogData._id,
      quantity: item.quantity,
    }));
    const transaction_id = select_transaction_id ? select_transaction_id : "";
    dispatch(
      ondcSelect({
        items,
        userAddress: defaultAddress?.address,
        userId: user?._id,
        transactionId: transaction_id,
        landingSource: localStorage.getItem("landingSource") ? localStorage.getItem("landingSource") : ""
      })
    )
      .then((response) => {
        setOndcCartData(response?.payload?.data);
        const deliveryTypeObj =
          response?.payload?.data?.message?.order?.fulfillments?.find(
            (item) => item.type === "Delivery"
          );
        setDeliveryTypeFulfillmentId(deliveryTypeObj?.id);
        setDeliveryType(deliveryTypeObj.type);
        calculateTotalItemAmount(response?.payload?.data, deliveryTypeObj?.id);
        if (
          response?.payload?.data &&
          response?.payload?.success &&
          !response?.payload?.data?.error
        ) {
          setError("");
          localStorage.setItem(
            "ondcCart",
            JSON.stringify(response?.payload?.data)
          );
          setLoading(false);
        } else {
          const error = errorCodeMessages(
            response?.payload?.data?.error?.code,
            response?.payload?.data?.error?.message
              ? response?.payload?.data?.error?.message
              : response?.payload?.message
          );
          const error_with_id = `${error}`;
          setError(error_with_id);
          setLoading(false);
        }
      })
      .catch((error) => {
        console.error("Error dispatching ondcCart:", error);
      });
  };

  function calculateTotalItemAmount(ondcCartData, deliveryTypeFulfillmentId) {
    if (!ondcCartData?.message?.order?.quote?.breakup) {
      return 0; // Return 0 if the required path is missing
    }
    const breakup = ondcCartData.message.order.quote.breakup;
    const totalItemAmountTemp = breakup.reduce((total, item) => {
      if (item["@ondc/org/title_type"] === "item") {
        return total + parseFloat(item?.price?.value || 0, 10);
      }
      return total;
    }, 0);

    const totalOtherChargesAmountTemp = breakup.reduce((total, item) => {
      if (
        !["item"].includes(item["@ondc/org/title_type"]) &&
        item["@ondc/org/item_id"] === deliveryTypeFulfillmentId
      ) {
        return total + parseFloat(item?.price?.value || 0, 10);
      }
      return total;
    }, 0);
    setFinalAmount(totalItemAmountTemp + totalOtherChargesAmountTemp);
    return totalItemAmountTemp + totalOtherChargesAmountTemp;
  }

  const updateCartItemQuantity = (itemId, newQuantity, singleCatalogData) => {
    const itemIndex = cartItemsTemp.findIndex((item) => item._id === itemId);
    if (newQuantity > parseInt(singleCatalogData.availableQuantity)) {
      notify(
        "success",
        "Available Quantity is only " + singleCatalogData?.availableQuantity
      );
    } else if (newQuantity > parseInt(singleCatalogData?.maximumQuantity)) {
      notify(
        "success",
        `Maximum quantity available is ${singleCatalogData?.maximumQuantity} for this product`
      );
    } else {
      if (itemIndex !== -1) {
        let updatedCartItems = [...cartItemsTemp];
        if (newQuantity === 0) {
          const arr = updatedCartItems.filter(function (item) {
            return item !== updatedCartItems[itemIndex];
          });
          updatedCartItems = arr;
        } else {
          updatedCartItems = cartItems.map((item, index) =>
            index === itemIndex ? { ...item, quantity: newQuantity } : item
          );
        }
        const existingProviderId = cartItems?.[0]?.catalogData?.providerId;
        if (
          existingProviderId &&
          updatedCartItems?.some(
            (item) => item?.catalogData?.providerId !== existingProviderId
          )
        ) {
          notify("error", "You can add items from a single store at a time.");
        } else {
          setCartItemsTemp(updatedCartItems);
          localStorage.setItem("cart", JSON.stringify(updatedCartItems));
          dispatch(updateCartItem(updatedCartItems));
          handleUpdateCartClicked(updatedCartItems);
          setSelectedCoupon(null);
          handleAddToCart(
            singleCatalogData.productName,
            singleCatalogData._id,
            singleCatalogData.subCategoryId,
            newQuantity,
            singleCatalogData.price,
            singleCatalogData.store?.name
          );
        }
      }
    }
  };

  const handleUpdateCartClicked = (updatedCartItems) => {
    dispatchOndcSelect(updatedCartItems);
  };

  const handleDeliveryTypeSelection = (data, type) => {
    const deliveryTypeFulfillment = data?.message?.order?.fulfillments.find(
      (item) => item.type === type
    );
    setDeliveryType(type);
    if (deliveryTypeFulfillment?.id) {
      setDeliveryTypeFulfillmentId(deliveryTypeFulfillment?.id);
      calculateTotalItemAmount(ondcCartData, deliveryTypeFulfillment?.id);
    }
  };

  const proeedToBuy = (orderId) => {
    if (orderId && orderId !== "" && user?._id) {
      setOpenRazorpay(true);
    } else {
      setError("Something Went Wrong ! Invalid Order Id");
    }
  };

  const handleBillingAddressSelection = () => {
    setBillingAddress(shippingAddress);
  };

  function triggerButtonClick() {
    const button = document.querySelector(".address-btn");
    if (button) {
      button.click();
    } else {
      console.error("Button not found");
    }
  }

  const handleShippingAddressSelection = (data) => {
    setShippingAddress(data);
    triggerButtonClick();
    const defaultAddress = {
      latitude: data?.region?.latitude,
      longitude: data?.region?.longitude,
      zipcode: data?.zipcode,
      address: data,
    };
    localStorage.setItem("defaultAddress", JSON.stringify(defaultAddress));
    dispatchOndcSelect(cartItemsTemp);
    updateStepCompletion(3, true);
  };

  const handleNewBillingAddressSelection = () => {
    store.dispatch(getLocations([]));
    setSearchModal(true);
    setOpenFromEdit();
    setIsNewBillingAddress(true);
    setEditAddress({});
  };
  useEffect(() => {
    setBillingAddress(shippingAddress);
  }, [shippingAddress]);

  const fetchAddress = () => {
    API.get(GET_USER_ADDRESS, { params: { userId: get(user, "_id", "") } })
      .then(({ data }) => {
        if (data) {
          setUserAddress(data.addresses);
        }
      })
      .catch((error) => {
        handleError(error);
      });
  };

  const handleGetCurrentLocation = () => {
    if (navigator.geolocation) {
      setGetCurrentLocationLoader(true);
      navigator.geolocation.getCurrentPosition(
        (position) => {
          const { latitude, longitude } = position.coords;

          if (openFromEdit) {
            setEditAddress({
              ...editAddress,
              region: {
                latitude: latitude,
                longitude: longitude,
              },
            });
          } else {
            setTempAddress({
              ...tempAddress,
              latitude: latitude,
              longitude: longitude,
            });
          }
          const obj = { latitude, longitude };
          getPlacesDetails(obj);
          setOpenFromEdit(false);
          setMap(true);
          setSearchModal(false);
          setGetCurrentLocationLoader(false);
        },
        (error) => {
          setGetCurrentLocationLoader(false);
          if (error.code === error.PERMISSION_DENIED) {
            notify(
              "error",
              "Allow location access in your browser to continue"
            );
          } else {
            notify(
              "error",
              "Error in facting your current location Try Again!"
            );
          }
        }
      );
    } else {
      console.error("Geolocation is not supported by this browser.");
    }
  };

  const updateAddress = () => {
    setLoadingAddAddress(true);

    const addressId = editAddress.addressId;
    if (!addressId) {
      console.error("Address ID is missing in editAddress:", editAddress);
      notify("error", "Address ID is missing in editAddress.");
      setLoadingAddAddress(false);
      return;
    }

    const region = {
      latitude: parseFloat(
        editAddress.latitude
          ? editAddress.latitude
          : editAddress.region?.latitude
      ),
      longitude: parseFloat(
        editAddress.longitude
          ? editAddress.longitude
          : editAddress.region?.longitude
      ),
    };
    if (
      (buyerName + editAddress?.building + editAddress?.address_line2)?.length >
      190
    ) {
      notify(
        "warning",
        "Max Character limit exceeded, Please write short address"
      );
      return;
    }

    const updatedBody = {
      addressId: addressId,
      contactName: buyerName,
      contactPhone: `+91${buyerNumber}`,
      mobile: buyerNumber,
      city: editAddress?.city,
      state: editAddress?.state,
      zipcode: editAddress?.pincode
        ? editAddress?.pincode
        : editAddress?.zipcode,
      address_line1: editAddress?.building ? editAddress?.building : "",
      address_line2: editAddress?.address_line2,
      building: editAddress?.building ?? "",
      status: editAddress?.status,
      tag: editAddress?.tag,
      region: region,
      emailId: emailId,
    };

    API.post("/edit-address", updatedBody)
      .then((res) => {
        const data = res?.data;
        if (data?.success) {
          fetchAddress();
        } else {
          notify(
            "error",
            "Error occurred while updating address. Please try again."
          );
        }
        setLoadingAddAddress(false);
      })
      .catch((error) => {
        console.error("Error:", error);
        notify(
          "error",
          "An error occurred while updating address. Please try again."
        );
        setLoadingAddAddress(false);
      });
  };

  const handleSaveAndProceed = () => {
    if (openFromEdit) {
      updateAddress();
      setMap(false);
    } else {
      if (!isNewBillingAddress) {
        saveAddress();
      } else {
        if ((buyerName + building + tempAddress?.address_line2)?.length > 190) {
          notify(
            "warning",
            "Max Character limit exceeded, Please write short address"
          );
          return;
        }
        const tempBillAddres = {
          contactName: buyerName,
          contactPhone: `+91${buyerNumber}`,
          mobile: buyerNumber,
          city: tempAddress.city,
          state: tempAddress.state,
          zipcode: tempAddress?.pincode
            ? tempAddress.pincode
            : tempAddress.zipcode,
          address_line1: building,
          address_line2: tempAddress.address_line2,
          building: building,
          status: tempAddress.status,
          tag: tempAddress.tag,
          emailId: emailId,
          userId: get(user, "userId", ""),
          uId: get(user, "_id", ""),
        };
        setBillingAddress(tempBillAddres);
        setMap(false);
      }
    }
  };

  const handleGetCurrentLocations = () => {
    const { region } = tempAddress;
    if (
      region &&
      region.latitude !== undefined &&
      region.longitude !== undefined
    ) {
      const latitude = Number(region.latitude);
      const longitude = Number(region.longitude);
      setMap(true);
      setSearchModal(false);
      getPlacesDetails({ latitude, longitude });
    } else {
      console.error(
        "Latitude or longitude is not available in the saved address."
      );
    }
  };

  const onChangePincodeDetail = (e) => {
    if (e.target.value !== "" && e.target.value.length >= 3) {
      handleAddress(e.target.value);
    } else {
      store.dispatch(startLoadingMap(false));
      store.dispatch(getLocations([]));
    }
  };
  const debouncedOnChange = debounce(onChangePincodeDetail, 500);

  const handleEditButtonClick = (data) => {
    const addressId = data.addressId || data._id || "";
    setTempAddress({});
    setEditAddress({
      ...data,
      addressId: addressId,
    });
    setOpenFromEdit(true);
    setMap(true);
    setBuyerName(data.contactName || "");
    setEmailId(data.emailId || "");
    setBuilding(data.building || "");
    if (
      data.region &&
      data.region.latitude !== undefined &&
      data.region.longitude !== undefined
    ) {
      handleGetCurrentLocations();
    }
  };

  const saveAddress = () => {
    const isTagValid = checkValidation(tempAddress?.tag);
    const isBuyerEmailValid = checkValidation(emailId);
    const isPhoneNumberValid = checkValidation(buyerNumber);
    const isPinCodeValid = checkValidation(
      tempAddress?.pincode ? tempAddress?.pincode : tempAddress?.zipcode
    );
    const isLandmarkValid = checkValidation(building);
    const isStateValid = checkValidation(tempAddress?.state);
    const isAddressLine2Valid = checkValidation(tempAddress?.address_line2);
    const isCityValid = checkValidation(tempAddress?.city);
    const isLatitudeValid = checkValidation(
      tempAddress.latitude
        ? tempAddress?.latitude
        : tempAddress?.region?.latitude
    );
    const isLongitudeValid = checkValidation(
      tempAddress?.longitude
        ? tempAddress?.longitude
        : tempAddress?.region?.longitude
    );
    if (
      !isTagValid ||
      !isPhoneNumberValid ||
      !isPinCodeValid ||
      !isLandmarkValid ||
      !isStateValid ||
      !isAddressLine2Valid ||
      !isCityValid
    ) {
      notify("warning", "Please enter valid details");
    } else if (
      !openFromEdit &&
      (!isBuyerEmailValid ||
        !isPhoneNumberValid ||
        !isPinCodeValid ||
        !isLandmarkValid ||
        !isStateValid ||
        !isAddressLine2Valid ||
        !isCityValid ||
        !isLatitudeValid ||
        !isLongitudeValid)
    ) {
      notify("warning", "Please enter valid details");
    } else {
      setLoadingAddAddress(true);
      const region = {
        latitude: parseFloat(
          tempAddress.latitude
            ? tempAddress.latitude
            : tempAddress.region?.latitude
        ),
        longitude: parseFloat(
          tempAddress.longitude
            ? tempAddress.longitude
            : tempAddress.region?.longitude
        ),
      };
      if ((buyerName + building + tempAddress?.address_line2)?.length > 190) {
        notify(
          "warning",
          "Max Character limit exceeded, Please write short address"
        );
        return;
      }

      const body = {
        contactName: buyerName,
        contactPhone: `+91${buyerNumber}`,
        mobile: buyerNumber,
        city: tempAddress.city,
        state: tempAddress.state,
        zipcode: tempAddress?.pincode
          ? tempAddress.pincode
          : tempAddress.zipcode,
        address_line1: building,
        address_line2: tempAddress.address_line2,
        building: building,
        status: tempAddress.status,
        tag: tempAddress.tag,
        emailId: emailId,
        region: region,
        userId: get(user, "userId", ""),
        uId: get(user, "_id", ""),
      };
      API.post("/create-address", body)
        .then((res) => {
          const data = res?.data;
          if (data.success) {
            const defaultAddress = {
              latitude: body?.region?.latitude,
              longitude: body?.region?.longitude,
              zipcode: body?.zipcode,
              address: body,
            };
            localStorage.setItem(
              "defaultAddress",
              JSON.stringify(defaultAddress)
            );
            setShippingAddress(body);
            fetchAddress();
          } else {
            notify(
              "error",
              "Error occurred while saving address. Please try again."
            );
          }
          setLoadingAddAddress(false);
        })
        .catch((error) => {
          notify(
            "error",
            "Error occurred while saving address. Please try again."
          );
          setLoadingAddAddress(false);
        });
    }
  };

  const SearchResult = (searches, save) => {
    const searchLocations = searches.map((item) => (
      <div
        className="select-location-result-item-kl"
        onClick={() => {
          setTempAddress({});
          placeDetail(item?.place_id);
          setOpenFromEdit(false);
          if (save) {
            store.dispatch(saveSearchHistory(item));
          }
        }}
      >
        <img src={blacksearchIcon} alt="Search Icon" />
        <div>
          <div className="select-location-pin-code-kl">{item?.structured_formatting?.main_text}</div>
          <div className="select-location-description-kl">{item?.description}</div>
        </div>
      </div>
    ));
    return <>{searchLocations}</>;
  };

  const handlePaymentResponse = async (payload) => {
    if (payload?.paymentResponse?.razorpay_payment_id) {
      try {
        setLoading(true);
        const razorpayAccount = "old-account";
        const token = JSON.parse(localStorage.getItem("token"));
        const options = {
          method: "post",
          url: `${process.env.REACT_APP_KIKO_API_BASE_URL_V2}/get-payment-details-razorpay`,
          headers: {
            Authorization: `${token}`,
            desktop: true,
          },
          data: {
            ondcOrderId: ondcOrderId,
            paymentId: payload?.paymentResponse?.razorpay_payment_id,
            razorpayAccount,
          },
        };
        await axios(options);
        const providerId = cartItems?.[0].catalogData?.providerId;
        const confirmObj = {
          userId: user?._id,
          transactionFee: payload?.transactionFee,
          razorPayTransactionId: payload?.paymentResponse.razorpay_payment_id,
          providerId: cartItems?.[0].catalogData?.providerId,
          orderId: ondcOrderId,
          landingSource: localStorage.getItem("landingSource") ? localStorage.getItem("landingSource") : ""
        };

        if (selectedCoupon) {
          confirmObj.offerData = {
            couponId: selectedCoupon?._id,
            perItemDiscount:
              discountAmount / (totalItemAmount + totalOtherChargesAmount),
            couponCode: selectedCoupon?.couponCode,
            discountedValue: discountAmount,
          };
          confirmObj.isOfferApplied = selectedCoupon?.isActive;
          confirmObj.quoteBreakup = ondcCartData?.message?.order?.quote?.breakup;
        }
        dispatch(ondcConfirm(confirmObj))
          .then((response) => {
            setPayableAmount(response?.payload?.data?.payableAmount);
            setLoading(false);
            if (response?.payload?.success) {
              const data = response?.payload?.data;
              data.providerId = providerId;
              setOrderDetails(data);
              // setOpenThankPopup(true);
              navigate("/")
              navigate("/thank-you", { state: { orderDetails: data, orderAmount: discountAmount ? response?.payload?.data?.payableAmount - discountAmount : response?.payload?.data?.payableAmount } })
              handlePurchase(
                cartItemsTemp?.[0]?.catalogData?.productName,
                cartItemsTemp?.[0]?.catalogData?._id,
                cartItemsTemp?.[0]?.catalogData?.subCategoryId,
                totalItemAmount,
                cartItemsTemp?.[0]?.catalogData?.store?.name
              );
            } else {
              const data = response?.payload;
              const err =
                data?.message ?? "Something Went Wrong! Please Try Again";
              const err_with_id = `${err}`;
              setErrorModalError(err_with_id);
              setOpenErrorModal(true);
            }
            localStorage.removeItem("cart");
            localStorage.removeItem("transaction_id");
            dispatch(updateCartItem([]));
          })
          .catch((error) => {
            setLoading(false);
            setError(error);
            console.error("Error dispatching ondc confirm:", error);
          });
      } catch (error) {
        setError("Payment Failed Please try again");
      }
    } else {
      setError("Payment Failed Please try again");
    }
  };

  const handleInit = () => {
    if (selectedCoupon) {
      dispatch(
        searchCoupon({
          userId: user?._id,
          providerId: cartItems?.[0]?.catalogData?.providerId,
          couponCode: selectedCoupon?.couponCode,
          orderValue: finalAmount,
          landingSource: localStorage.getItem("landingSource") ? localStorage.getItem("landingSource") : ""
        })
      )
        .then((response) => {
          if (!response.payload) {
            notify("error", "Invalid response from server");
            return;
          }
          const coupons = response?.payload?.coupons || [];
          const nonQCCoupons = landingSource !== `${process.env.REACT_APP_LANDING_SOURCE}` ? coupons.filter((coupon) => coupon?.isForQC !== true) : coupons;
          const isActive = nonQCCoupons?.length > 0 && nonQCCoupons?.[0]?.isActive === true;
          if (response?.payload?.success && isActive) {
            executeInit();
          } else {
            notify(
              "error",
              response?.payload?.message || "Coupon limit reached"
            );
          }
        })
        .catch((error) => {
          alert("An error occurred while applying the coupon");
          console.error("Coupon apply error:", error);
        });
    } else {
      executeInit();
    }
  };

  const executeInit = () => {
    const payload = {
      userId: user?._id,
      billingAddress: {
        address: {
          name: billingAddress?.contactName,
          building: billingAddress?.building,
          locality: billingAddress?.address_line2,
          city: billingAddress?.city,
          state: billingAddress?.state,
          country: "IND",
          area_code: billingAddress?.zipcode,
        },
        name: billingAddress?.contactName,
        email: billingAddress?.emailId,
        phone: billingAddress?.mobile
          ? billingAddress?.mobile
          : billingAddress?.contactPhone,
      },
      shippingAddress,
      deliveryType: deliveryType,
      fulfillmentId: deliveryTypeFulfillmentId,
      orderValue: parseFloat(totalItemAmount),
      landingSource: localStorage.getItem("landingSource") ? localStorage.getItem("landingSource") : ""
    };

    dispatch(ondcInit(payload)).then((res) => {
      setOndcOrderId(res?.payload?.data?.ondcOrderId);
      const data = res?.payload;
      if (data?.success && !data?.error) {
        setError("");
        if (data?.data?.ondcOrderId) {
          handleCheckout(
            cartItemsTemp?.[0]?.catalogData?.productName,
            cartItemsTemp?.[0]?.catalogData?._id,
            cartItemsTemp?.[0]?.catalogData?.subCategoryId,
            totalItemAmount,
            cartItemsTemp?.[0]?.catalogData?.store?.name
          );
          proeedToBuy(data?.data?.ondcOrderId);
        }
      } else {
        const err = data?.message ?? "Something Went Wrong! Please Try Again";
        const err_with_id = `${err}`;
        setError(err_with_id);
        setLoading(false);
      }
    });
  };

  const updateStepCompletion = (stepId, isCompleted) => {
    setAccordionSteps((prevSteps) =>
      prevSteps.map((step) =>
        step.id === stepId ? { ...step, completed: isCompleted } : step
      )
    );
  };

  let totalItemAmount = 0;
  let totalOtherChargesAmount = 0;

  const disableCartItemInteraction = () => {
    return loading;
  };

  const applyCoupon = async (coupon) => {
    try {
      if (selectedCoupon && selectedCoupon?.couponCode === coupon?.couponCode) {
        notify("info", "Coupon already applied");
        setCouponInput("");
        setApplyCouponError("")
        return;
      }
      const response = await dispatch(
        searchCoupon({
          userId: user?._id,
          providerId: cartItems?.[0]?.catalogData?.providerId,
          couponCode: coupon.couponCode,
          orderValue: finalAmount,
          landingSource: localStorage.getItem("landingSource") ? localStorage.getItem("landingSource") : ""
        })
      );
      if (!response.payload) {
        notify("error", "Invalid response from server");
        return;
      }
      const coupons = response.payload.coupons || [];
      const nonQCCoupons = landingSource !== `${process.env.REACT_APP_LANDING_SOURCE}` ? coupons.filter((coupon) => coupon?.isForQC !== true) : coupons;
      const isActive = nonQCCoupons.length > 0 && nonQCCoupons[0].isActive === true;
      if (response?.payload?.success && isActive) {
        setSelectedCoupon(nonQCCoupons[0]);
        notify("success", "Coupon Applied Successfully");
      } else {
        notify("error", response?.payload?.message || "Coupon limit reached");
      }
    } catch (error) {
      alert("An error occurred while applying the coupon");
      console.error("Coupon apply error:", error);
    }
  };

  let discountAmount = 0;

  const handleCouponClick = (coupon) => {
    setSelectedTC(coupon);
    setOpenDropdownId((prevId) =>
      prevId === coupon?._id ? null : coupon?._id
    );
  };

  const handleSearchApplyCoupon = async () => {
    if (selectedCoupon && selectedCoupon?.couponCode === couponInput) {
      notify("info", "Coupon already applied");
      setCouponInput("");
      setApplyCouponError("")
      return;
    }
    try {
      const response = await dispatch(
        searchCoupon({
          userId: user?._id,
          providerId: cartItems?.[0]?.catalogData?.providerId,
          couponCode: couponInput,
          orderValue: finalAmount,
          landingSource: localStorage.getItem("landingSource") ? localStorage.getItem("landingSource") : ""
        })
      );
      if (!response.payload) {
        notify("error", "Invalid response from server");
        return;
      }

      const coupons = response.payload.coupons || [];
      const nonQCCoupons = landingSource !== `${process.env.REACT_APP_LANDING_SOURCE}` ? coupons.filter((coupon) => coupon?.isForQC !== true) : coupons;
      const isActive = nonQCCoupons.length > 0 && nonQCCoupons[0].isActive === true;
      const isSuccess = response.payload.success === true;

      if (isSuccess && isActive) {
        setSelectedCoupon(nonQCCoupons[0]);
        setCouponInput("");
        setApplyCouponError("")
        hiddenCloseRef.current?.click();
        notify("success", "Coupon Applied Successfully");
      } else {
        setCouponInput("");
        setApplyCouponError(response?.payload?.message || "Coupon limit reached")
        // notify("error", response?.payload?.message || "Coupon limit reached");
      }
    } catch (error) {
      alert("An error occurred while applying the coupon");
      console.error("Coupon apply error:", error);
    }
  };

  const nonQCCoupons = landingSource !== `${process.env.REACT_APP_LANDING_SOURCE}` ? coupons.filter((coupon) => coupon?.isForQC !== true) : coupons;
  return (
    <>
      {process.env.REACT_APP_NODE_ENV === "production" && localStorage.getItem("landingSource")?.includes("qc") && (
        <Helmet>
          <script>
            {`!function(f,b,e,v,n,t,s)
{if(f.fbq)return;n=f.fbq=function(){n.callMethod?
n.callMethod.apply(n,arguments):n.queue.push(arguments)};
if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
n.queue=[];t=b.createElement(e);t.async=!0;
t.src=v;s=b.getElementsByTagName(e)[0];
s.parentNode.insertBefore(t,s)}(window, document,'script',
'https://connect.facebook.net/en_US/fbevents.js');
fbq('init', '326242339368504');
fbq('track', 'PageView');
fbq('track', 'InitiateCheckout');`}
          </script>
          <noscript>
            {`<img height="1" width="1" style="display:none"
src="https://www.facebook.com/tr?id=326242339368504&ev=PageView&noscript=1"
/>`}
          </noscript>
        </Helmet>
      )}
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
      <ToastContainer />
      <Header />
      <div className="category-section buyer-checkout-page-kl">
        <div className="container">
          {cartItemsTemp && cartItemsTemp.length > 0 ? (
            <div className="cart-details-kl">
              <div className="row">
                <div className="col-lg-8">
                  <div className="checkout-card-kl">
                    <div className="checkout-card-header-kl">
                      <div className="checkout-card-header-title-kl">
                        {accordionSteps[0].completed ? (
                          <div className="checkout-card-check-icon-kl">
                            <img src={RightIcon} alt="Empty Cart" />
                          </div>
                        ) : (
                          <div className="iconCounter activeCounter">1</div>
                        )}
                        Cart
                      </div>
                    </div>
                    <div className="checkout-card-body-kl">
                      {cartItemsTemp &&
                        cartItemsTemp?.length > 0 &&
                        cartItemsTemp?.map((cartData, index) => {
                          return (
                            <div key={index}>
                              <div className="checkout-card-list-kl">
                                <div className="checkout-card-items-kl">
                                  <div className="checkout-card-items-left-kl">
                                    <div className="checkout-card-product-img-kl">
                                      <img
                                        alt="Grocery"
                                        src={
                                          cartData?.catalogData
                                            ?.productImages[0]
                                        }
                                      />
                                    </div>
                                    <div className="checkout-card-details-kl">
                                      <div className="checkout-card-product-title">
                                        {" "}
                                        {cartData?.catalogData?.productName}
                                      </div>
                                      <div className="checkout-card-product-price">
                                        {`₹ ${cartData?.catalogData?.price}`}
                                      </div>
                                      <div className="checkout-card-shop-name-kl">
                                        {cartData?.catalogData?.store
                                          ?.name ?? ""}
                                      </div>
                                    </div>
                                  </div>
                                  <div
                                    className="checkout-card-add-qty-kl"
                                    style={{ position: "unset" }}
                                  >
                                    <div
                                      className={`checkout-card-count-btn-kl ${disableCartItemInteraction() &&
                                        "disabled"
                                        }`}
                                      onClick={() => {
                                        !disableCartItemInteraction() &&
                                          updateCartItemQuantity(
                                            cartData._id,
                                            cartData.quantity === 1
                                              ? 0
                                              : cartData.quantity - 1,
                                            cartData.catalogData
                                          );
                                      }}
                                    >
                                      <MinusIcon />
                                    </div>
                                    <div className="checkout-card-count-btn-kl">{cartData.quantity}</div>
                                    <div
                                      className={`checkout-card-count-btn-kl ${disableCartItemInteraction() &&
                                        "disabled"
                                        }`}
                                      onClick={() => {
                                        !disableCartItemInteraction() &&
                                          updateCartItemQuantity(
                                            cartData?._id,
                                            cartData.quantity + 1,
                                            cartData.catalogData
                                          );
                                      }}
                                    >
                                      <PlusIcon />
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          );
                        })}
                      <div onClick={() => {
                        const providerId = cartItemsTemp?.[0]?.catalogData?.providerId
                        const encodedValue = encodeURIComponent(providerId);
                        navigate(`/seller?pid=${encodedValue}`);
                      }} className="add-product-more-items-list-kl">
                        <div className="add-product-items-kl">Add More Items</div>
                      </div>
                      <div
                        className="accordion buyerCheckoutCollapse"
                        id="accordionExample"
                      >
                        <div className="accordion-item">
                          <h2 className="accordion-header" id="headingFour">
                            <button
                              className="accordion-button collapsed"
                              type="button"
                            >
                              {accordionSteps[0].completed ? (
                                <div className="checkout-card-check-icon-kl">
                                  {" "}
                                  <img src={RightIcon} alt="Empty Cart" />
                                </div>
                              ) : (
                                <div
                                  className={`iconCounter ${accordionSteps[0].completed
                                    ? "activeCounter"
                                    : ""
                                    }`}
                                >
                                  2
                                </div>
                              )}
                              Add Address
                            </button>
                            <div className="change-address-btn-kl">
                              {showAddressEdit && (
                                <button
                                  type="button"
                                  className="address-btn"
                                  data-bs-toggle="collapse"
                                  data-bs-target="#collapseFour"
                                  aria-expanded="false"
                                  aria-controls="collapseFour"
                                  onClick={() => {
                                    setShowAddressEdit(false);
                                  }}
                                >
                                  Edit
                                </button>
                              )}
                              {!loading && (
                                <button
                                  type="button"
                                  data-bs-toggle="collapse"
                                  data-bs-target="#collapseFour"
                                  aria-controls="collapseFour"
                                  aria-expanded="true"
                                  className="address-btn"
                                  onClick={() => {
                                    updateStepCompletion(3, true);
                                  }}
                                >
                                  Change Address
                                </button>
                              )}
                            </div>
                          </h2>
                          <div
                            id="collapseFour"
                            className="accordion-collapse collapse"
                            aria-labelledby="headingFour"
                            data-bs-parent="#accordionExample"
                          >
                            <div className="accordion-body pt-0">
                              <div>
                                <div>
                                  <div></div>
                                  {userAddress &&
                                    userAddress.length > 0 &&
                                    userAddress?.map((data, index) => (
                                      <div
                                        key={data?._id}
                                        className="shipping-address-card"
                                      >
                                        <div className="shipping-address-btn">
                                          <input
                                            type="radio"
                                            id={`Shipping${index}`}
                                            name="shippingAddress"
                                            onChange={() =>
                                              handleShippingAddressSelection(data)
                                            }
                                            checked={
                                              data?._id === shippingAddress?._id
                                            }
                                          />
                                          <label
                                            htmlFor={`Shipping${index}`}
                                          >
                                            <div className="shipping-address">
                                              {`${data.contactName}, ${data.address_line2}, Pin Code: ${data.zipcode} `}
                                              <br />
                                              {`phone: ${data.contactPhone}`}
                                            </div>
                                          </label>

                                        </div>
                                        <div className="right-content">

                                          <button
                                            type="button"
                                            className="btn  edit-icon"
                                            onClick={() => {
                                              setOpenFromEdit(true);
                                              fetchAddress();
                                              setTempAddress(data);
                                              setEditAddress(data);
                                              handleEditButtonClick(data);
                                            }}
                                          >
                                            <EditIcon />
                                          </button>
                                        </div>
                                      </div>
                                    ))}
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="billing-shipping-flex">
                            <div className="billing-shipping-item">
                              <div className="address-title">Shipping Address</div>
                              {shippingAddress?.address_line2 ? (
                                <div className="billing-address-content">
                                  <div className="shipping-address">
                                    {`${shippingAddress.contactName}, ${shippingAddress.address_line2}, ${shippingAddress?.zipcode}`}
                                  </div>
                                  <div className="shipping-address">
                                    {`phone: ${shippingAddress.contactPhone}`}
                                  </div>
                                </div>
                              ) : (
                                <p>No shipping address selected</p>
                              )}
                            </div>
                            <div className="billing-shipping-item">
                              <div className="address-title">Billing Address</div>
                              {billingAddress ? (
                                <div className="billing-address-content">
                                  <div className="billing-address">
                                    {`${billingAddress?.contactName}, ${billingAddress?.address_line2}, ${billingAddress?.zipcode}`}
                                  </div>
                                  <div className="billing-address">
                                    {`phone: ${billingAddress?.contactPhone}`}
                                  </div>
                                </div>
                              ) : (
                                <p>No billing address selected</p>
                              )}
                            </div>
                          </div>
                          <div className="add-new-billing">
                            <div className="add-new-list">
                              <input
                                type="radio"
                                id="sameAddress"
                                name="addressType"
                                onChange={handleBillingAddressSelection}
                                checked={billingAddress === shippingAddress}
                              />
                              <label htmlFor="sameAddress">
                                <span className="billing-address-text">
                                  My billing and shipping address are the same
                                </span>
                              </label>
                            </div>
                            <div className="add-new-list">
                              <input
                                type="radio"
                                id="differentAddress"
                                onChange={handleNewBillingAddressSelection}
                                name="addressType"
                                checked={searchmodal && isNewBillingAddress}
                              />
                              <label htmlFor="differentAddress">
                                <span className="billing-address-text">
                                  Add New Billing Address
                                </span>
                              </label>
                            </div>
                          </div>
                          <button
                            type="button"
                            className="btn new-address-btn"
                            onClick={() => {
                              store.dispatch(getLocations([]));
                              setSearchModal(true);
                              setIsNewBillingAddress(false);
                              setOpenFromEdit();
                              setEditAddress({});
                            }}
                          >
                            <svg
                              className="MuiSvgIcon-root MuiSvgIcon-fontSizeMedium jss132 css-vubbuv"
                              focusable="false"
                              aria-hidden="true"
                              viewBox="0 0 24 24"
                              data-testid="AddCircleOutlineRoundedIcon"
                            >
                              <path d="M12 7c-.55 0-1 .45-1 1v3H8c-.55 0-1 .45-1 1s.45 1 1 1h3v3c0 .55.45 1 1 1s1-.45 1-1v-3h3c.55 0 1-.45 1-1s-.45-1-1-1h-3V8c0-.55-.45-1-1-1zm0-5C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"></path>
                            </svg>
                            Add new address
                          </button>
                          <div
                            className="modal fade remove-coupon-modal"
                            id="removeModal"
                            tabIndex="-1"
                            aria-labelledby="removeModalLabel"
                            aria-hidden="true"
                          >
                            <div className="modal-dialog modal-dialog-centered">
                              <div className="modal-content">
                                <div className="modal-body">
                                  <div className="Remove-coupon-title">
                                    Remove Coupon
                                  </div>
                                  <div className="remove-alert">
                                    Do you want to remove coupon?
                                  </div>
                                </div>
                                <div className="modal-footer">
                                  <button
                                    type="button"
                                    className="btn"
                                    data-bs-dismiss="modal"
                                    onClick={() => setSelectedCoupon(null)}
                                  >
                                    Remove
                                  </button>
                                  <button
                                    type="button"
                                    className="btn active"
                                    data-bs-dismiss="modal"
                                  >
                                    Keep
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="col-lg-4">
                  <div className="summary-mobile-title"></div>
                  <div className="checkout-card-kl checkout-card-summary-amount-kl">
                    {ondcCartData?.message?.order?.quote?.breakup?.map(
                      (item, index) => {
                        totalItemAmount +=
                          item["@ondc/org/title_type"] === "item"
                            ? parseFloat(item?.price?.value)
                            : 0;
                        return item["@ondc/org/title_type"] === "item" && <></>;
                      }
                    )}
                    <div className="checkout-card-header-kl">
                      <div className="checkout-card-header-title-kl">Order Summary</div>
                    </div>
                    <div className="checkout-card-body-kl">
                      <div className="checkout-card-item-total-list">
                        <div className="checkout-card-item-total-items">
                          <span>Item Total</span>
                          <span>₹ {totalItemAmount?.toFixed(2)}</span>
                        </div>
                        <span>Fulfillment
                          {ondcCartData?.message?.order?.fulfillments
                            .filter((delivery) => delivery.type === deliveryType)
                            .map((delivery, index) => (
                              <span
                                key={index}
                                htmlFor={`deliveryType${index}`}
                                className="immediate-delivery-kl"
                              >
                                ({delivery["@ondc/org/category"]} -{" "}
                                {delivery?.state?.descriptor?.code})
                              </span>
                            ))}
                        </span>
                        <div className="checkout-card-item-total-items">
                          <div className="checkout-card-items-charges-items">
                            {ondcCartData?.message?.order?.fulfillments?.map(
                              (delivery, index) => (
                                <div className="delivery-radio-btn-kl">
                                  <input
                                    type="radio"
                                    id={`${delivery?.type}`}
                                    onChange={() =>
                                      handleDeliveryTypeSelection(
                                        ondcCartData,
                                        delivery?.type
                                      )
                                    }
                                    name={`${delivery?.type}`}
                                    checked={deliveryType === delivery?.type}
                                  />
                                  <label htmlFor={`${delivery?.type}`}>
                                    <span className="deliver-label-kl">{`${delivery?.type}`}</span>
                                  </label>
                                </div>
                              )
                            )}
                          </div>
                        </div>
                      </div>
                      <div className="checkout-card-items-charges-list">
                        {ondcCartData?.message?.order?.quote?.breakup?.map(
                          (item, index) => {
                            if (
                              !["item"].includes(item["@ondc/org/title_type"]) &&
                              item["@ondc/org/item_id"] ===
                              deliveryTypeFulfillmentId
                            ) {
                              totalOtherChargesAmount += parseFloat(
                                item?.price?.value
                              );
                            }
                            discountAmount =
                              (selectedCoupon &&
                                (selectedCoupon?.discountType === "percentage"
                                  ? Math.min(
                                    (parseFloat(
                                      selectedCoupon?.couponDiscount
                                    ) /
                                      100) *
                                    (totalItemAmount +
                                      totalOtherChargesAmount),
                                    selectedCoupon?.maximumDiscountAmount
                                  )
                                  : parseFloat(
                                    selectedCoupon?.couponDiscount
                                  ))) ||
                              0;
                            return (
                              item["@ondc/org/title_type"] !== "item" &&
                              item["@ondc/org/item_id"] ===
                              deliveryTypeFulfillmentId && (
                                <>
                                  <div
                                    className="checkout-card-items-charges-items"
                                    key={index}
                                  >
                                    {item?.title && (
                                      <span>
                                        {item?.title}
                                      </span>
                                    )}

                                    <span>
                                      {item["@ondc/org/item_quantity"] && (
                                        <span className="charges-base-price-kl">
                                          {item["@ondc/org/item_quantity"]?.count} *
                                          Base Price
                                        </span>
                                      )}
                                      ₹{item?.price?.value}
                                    </span>
                                  </div>
                                </>
                              )
                            );
                          }
                        )}

                        <div className="checkout-card-items-charges-items">
                          <span>Tax:</span>
                          <span>₹ 0</span>
                        </div>
                      </div>

                      <div className="checkout-card-item-total-list">
                        <div className="checkout-card-item-total-items">
                          <span>Sub Total</span>
                          <span>
                            ₹{totalOtherChargesAmount.toFixed(2)}
                          </span>
                        </div>
                        <div className="checkout-card-item-total-items">
                          <span>Total Amount</span>
                          <span>
                            ₹
                            {(totalItemAmount + totalOtherChargesAmount).toFixed(
                              2
                            )}
                          </span>
                        </div>
                        {selectedCoupon && (
                          <>
                            <div className="checkout-card-item-total-items">
                              {
                                <span
                                  className="offer-items-kl"
                                >
                                  {`Offer Applied (${selectedCoupon?.couponCode})`}
                                </span>
                              }
                              <span
                                className="offer-items-kl"
                              >
                                - ₹{discountAmount?.toFixed(2)}
                              </span>
                            </div>

                            <div className="checkout-card-item-total-items border-0 mb-0">
                              <span>
                                Grand Total
                              </span>
                              <span>
                                ₹
                                {(
                                  totalItemAmount +
                                  totalOtherChargesAmount -
                                  discountAmount
                                ).toFixed(2)}
                              </span>
                            </div>
                          </>
                        )}
                      </div>
                      {selectedCoupon && (
                        <div className="applied-coupon-kl">
                          <div className="applied-coupon-container-kl">
                            <div className="applied-coupon-left-kl">
                              <div className="applied-text-kl">
                                {selectedCoupon?.couponCode} applied{" "}
                                <img src={AppliedCoupon} alt="Icon" />
                              </div>

                              <div className="applied-successfull-kl">
                                You have successfully saved ₹
                                {discountAmount?.toFixed(2)} on order
                              </div>
                            </div>
                            <div className="applied-coupon-right-kl">
                              <button
                                className="remove-coupon-kl"
                                type="button"
                                data-bs-toggle="modal"
                                data-bs-target="#removeModal"
                              >
                                Remove
                              </button>
                            </div>
                          </div>
                          <div
                            className="view-other-coupon-kl"
                            data-bs-toggle="modal"
                            data-bs-target="#availoffer"
                          >
                            <div className="view-coupon-text-kl">
                              View other offers
                            </div>
                            <button
                              type="button"
                              className="other-coupon-button-kl"
                            ></button>
                          </div>
                        </div>
                      )}
                      {!selectedCoupon && nonQCCoupons?.length > 0 && (
                        <div className="offer-coupon-desktop-kl-">
                          <div
                            className="avail-offer-coupon-kl"
                            data-bs-toggle="modal"
                            data-bs-target="#availoffer"
                          >
                            <div className="avail-offer-left">
                              <img src={AvailOfferIcon} alt="Icon" />
                              <div className="avail-offer-text-kl">
                                Avail Offer / Coupon
                              </div>
                            </div>
                            <button type="button" className="avail-offer-button">
                              <img src={OfferRight} alt="Icon" />
                            </button>
                          </div>
                        </div>
                      )}
                      <div className="proceed-by-btn-desktop-kl">
                        <button
                          type="button"
                          className="btn btn-primary proceed-to-buy"
                          onClick={() => handleInit()}
                          disabled={
                            error ||
                            ondcIsCartError ||
                            loading ||
                            ondcConfirmstatus === "loading" ||
                            !accordionSteps.every((step) => step?.completed) ||
                            couponStatus === "loading"
                          }
                        >
                          {loading ||
                            ondcInitstatus === "loading" ||
                            couponStatus === "loading" ||
                            searchCouponStatus === "loading" ? (
                            <LoaderWhite />
                          ) : (
                            "Proceed To Buy"
                          )}
                        </button>
                        {error !== "" && <p className="error">{error}</p>}
                      </div>
                    </div>
                    <>
                      <div
                        className="modal fade avail-offer-coupon-modal custom-modal-kl"
                        id="availoffer"
                        tabIndex="-1"
                        aria-labelledby="availofferLabel"
                        aria-hidden="true"
                      >
                        <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable">
                          <div className="modal-content">
                            <div className="modal-header">
                              <h5 className="modal-title" id="availofferLabel">
                                Apply Coupon
                              </h5>
                              <button
                                type="button"
                                onClick={() => {
                                  setCouponInput("")
                                  setApplyCouponError("")
                                }}
                                className="close-icon-kl"
                                data-bs-dismiss="modal"
                                ref={hiddenCloseRef}
                                aria-label="Close"
                              ></button>
                            </div>
                            <div className="modal-body">
                              <div className="coupon-form-container-kl">
                                <input
                                  className="form-control form-control-lg"
                                  type="text"
                                  placeholder="Enter Coupon Code"
                                  value={couponInput}
                                  onChange={(e) => {
                                    setCouponInput(e.target.value)
                                    setApplyCouponError("")
                                  }
                                  }
                                />
                                <button
                                  disabled={!couponInput}
                                  // data-bs-dismiss="modal"
                                  onClick={handleSearchApplyCoupon}
                                  className="coupon-apply-btn-kl"
                                >
                                  Apply
                                </button>
                              </div>
                              {applyCouponError &&
                                <div
                                  className="apply-coupon-discount-worth-kl"
                                  style={{
                                    alignSelf: 'flex-end',
                                    margin: "7px",
                                    textAlign: 'left',
                                  }}
                                >
                                  {applyCouponError}
                                </div>
                              }
                              <div className="available-offer-heading-kl">
                                {nonQCCoupons?.some(
                                  (coupon) =>
                                    coupon.status
                                )
                                  ? "Available Offers"
                                  : "No Available Offers"}
                              </div>
                              <div className="apply-coupon-list-kl">
                                {nonQCCoupons?.map(
                                  (coupon, index) =>
                                    coupon.status && (
                                      <div
                                        key={`${coupon.couponCode}-${index}`}
                                        className="apply-coupon-items-kl"
                                      >
                                        <div className="apply-coupon-items-inner-kl coupon-item">
                                          <div className="apply-coupon-items-inner-left-kl">
                                            <div className="apply-coupon-header-kl">
                                              <div className="apply-coupon-flatdeal-text-kl">
                                                {coupon.couponCode}
                                              </div>
                                              <div className="apply-coupon-discount-worth-kl">
                                                {coupon.couponName}
                                              </div>
                                            </div>
                                            <div className="apply-coupon-flat-discount-kl">
                                              {coupon.couponDescription}
                                            </div>
                                            {coupon.isActive === false && (
                                              <div
                                                className="apply-coupon-discount-worth-kl"
                                                style={{
                                                  marginTop: "10px",
                                                }}
                                              >
                                                Coupon limit reached*
                                              </div>
                                            )}
                                          </div>
                                          <div className="apply-coupon-items-inner-right-kl">
                                            <button
                                              className="btn btn-primary apply-applied-btn-kl"
                                              type="button"
                                              data-bs-dismiss="modal"
                                              onClick={() =>
                                                applyCoupon(coupon)
                                              }
                                              style={{
                                                opacity:
                                                  finalAmount >= coupon.minimumOrderValue &&
                                                    finalAmount <= coupon.maximumOrderValue &&
                                                    coupon.status &&
                                                    coupon.isActive === true
                                                    ? 1
                                                    : 0.5,
                                              }}
                                              disabled={
                                                finalAmount <= coupon.minimumOrderValue ||
                                                finalAmount >= coupon.maximumOrderValue ||
                                                !coupon.status ||
                                                coupon?.isActive !== true
                                              }
                                            >
                                              {selectedCoupon?.couponCode ===
                                                coupon?.couponCode
                                                ? "Applied"
                                                : "Apply"}
                                            </button>
                                          </div>
                                        </div>
                                        <div className="tc-content-block-kl">
                                          <span className="left-shape-hidden-kl"></span>
                                          <span className="right-shape-hidden-kl"></span>
                                          <span></span>
                                          <span
                                            className="terms-and-condition-btn-kl"
                                            id="Popover1"
                                            onClick={() =>
                                              handleCouponClick(coupon)
                                            }
                                          >
                                            T&C
                                            <img
                                              src={bottomArrowCoupon}
                                              alt="Icon"
                                              className={
                                                openDropdownId === coupon?._id
                                                  ? "tc-content-open"
                                                  : ""
                                              }
                                            />
                                          </span>
                                          {openDropdownId === coupon?._id && (
                                            <div className="hidden-tc-content-kl">
                                              <ol>
                                                {selectedTC &&
                                                  selectedTC?.couponTC ? (
                                                  selectedTC?.couponTC
                                                    .trim()
                                                    .split("\n")
                                                    .map((line, index) => (
                                                      <li key={index}>
                                                        {line}
                                                      </li>
                                                    ))
                                                ) : (
                                                  <li>
                                                    No terms and conditions
                                                    available
                                                  </li>
                                                )}
                                              </ol>
                                            </div>
                                          )}
                                        </div>
                                      </div>
                                    )
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </>
                  </div>
                </div>
              </div>
            </div>
          ) : (
            <div className="no-items">
              <img src={EmptyCart} alt="Empty Cart" />
              <h6>
                Looks like you don't have any <br /> products in your cart
              </h6>
              <p
                onClick={() => navigate("/")}
                type="button"
                style={{ textDecoration: "underline" }}
              >
                Shop now
              </p>
            </div>
          )}
        </div>
        <div className="proceed-by-btn-mobile-kl">
          <button
            type="button"
            className="btn btn-primary"
            onClick={() => handleInit()}
            disabled={
              error ||
              ondcIsCartError ||
              loading ||
              ondcConfirmstatus === "loading" ||
              !accordionSteps.every((step) => step?.completed) ||
              couponStatus === "loading" ||
              searchCouponStatus === "loading"
            }
          >
            {loading ||
              ondcInitstatus === "loading" ||
              couponStatus === "loading" ||
              searchCouponStatus === "loading" ||
              searchCouponStatus === "loading" ? (
              <LoaderWhite />
            ) : (
              "Proceed To Buy"
            )}
          </button>
          {error !== "" && <p className="error">{error}</p>}
        </div>
      </div>
      <Modal
        isOpen={searchmodal}
        toggle={() => {
          setSearchModal(false);
        }}
        aria-labelledby="contained-modal-title-v"
        ed
        style={{ maxWidth: "600px" }}
        centered
        className="custom-modal-kl"
      >
        <div className="custom-modal-header-kl">
          <div className="custom-modal-title-kl">Select Location</div>
        </div>
        <div className="custom-modal-body-kl select-location-modal-kl">
          <div className="select-location-search-kl">
            <img src={searchIcon} alt="Search1 Icon" className="select-location-search-icon-kl" />
            <input
              className="form-control"
              type="search"
              placeholder="Search for an area , Location name, Pincode"
              onChange={debouncedOnChange}
            />
          </div>
          {loadingMapAddress && !selectAddressLoader && <Loader />}
          <div className="select-location-list-kl">
            <div className="select-location-items">
              <img src={CurrentLocationIcon} alt="Location Icon" className="location-icon-kl" />
              {getCurrentLocationLoader ? (
                <Loader />
              ) : (
                <button type="button"
                  className="current-location-btn-kl"
                  onClick={() => {
                    handleGetCurrentLocation();
                    setBuyerName()
                    setBuilding()
                    setEmailId()

                  }}
                >
                  Use My Current Location{" "}
                </button>
              )}
            </div>
            <div className="select-location-items">
              <img src={LocationPinIcon} alt="Location Icon" className="location-icon-kl" />
              {getCurrentLocationLoader ? (
                <Loader />
              ) : (
                <button type="button"
                  className="current-location-btn-kl"
                  onClick={() => {
                    handleGetCurrentLocation();
                    setBuyerName()
                    setBuilding()
                    setEmailId()

                  }}
                >
                  Locate On Map{" "}
                </button>
              )}
            </div>
          </div>
          <div className="select-location-container-kl">
            <ul className="nav nav-tabs" role="tablist">
              <li className="nav-item">
                <button
                  className={`nav-link ${activeTab === "tabs-1" ? "active" : ""}`}
                  onClick={() => setActiveTab("tabs-1")}
                >
                  {locations.length > 0 ? "Choose Delivery Location" : "Recent Search"}
                </button>
              </li>
            </ul>
            <div className="tab-content">
              <div className={`tab-pane ${activeTab === "tabs-1" ? "active show" : ""}`}>
                <div className={"select-location-result-list-kl"}>
                  {locations.length > 0 ? SearchResult(locations, true) : recentSearches?.length > 0 ? SearchResult(recentSearches, false) : "Your recent searches will appear here."}
                </div>
              </div>
            </div>
          </div>
        </div>
      </Modal>
      <Modal
        isOpen={map}
        aria-labelledby="contained-modal-title-v"
        ed
        toggle={() => {
          setMap(false);
        }}
        className="custom-modal-kl confirm-delivery-location-modal modal-md"
        centered
      >
        <div className="custom-modal-header-kl">
          <div className="custom-modal-title-kl">
            <button className="custom-modal-header-back-arrow"
              data-bs-dismiss="offcanvas"
              aria-label="Close"
              onClick={() => {
                setMap(false);
              }}
            >
              <img src={ArrowBack} alt="" />
            </button>
            {editAddress?.addressId ? "Edit Address" : "Confirm Delivery Location"}
          </div>
          <button
            type="button"
            className="close-icon-kl text-reset"
            data-bs-dismiss="offcanvas"
            aria-label="Close"
            onClick={() => {
              setMap(false);
            }}
          ></button>
        </div>
        <ModalBody className="custom-modal-body-kl">
          <div className="row">
            <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 mb-3">
              <input
                type="text"
                className="form-control"
                placeholder="Full Name*"
                value={buyerName}
                onChange={(e) => {
                  setBuyerName(e.target.value);
                }}
              />
              {checkValidation(buyerName) ? null : (
                <p className="error">Name is required.</p>
              )}
            </div>
            <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12 mb-3">
              <input
                type="text"
                className="form-control "
                placeholder="Email Id*"
                value={emailId}
                onChange={(e) => {
                  setEmailId(e.target.value);
                }}
              />
              {checkEmailPhoneValidation("email", emailId) ? null : (
                <p className="error">Please enter a valid email address.</p>
              )}
            </div>
            <div className="dropLocation-modal-kl">
              <div className="dropLocation-modal-lock-kl">
                {
                  <WrappedMap
                    currLatlong1={{
                      latitude: openFromEdit ? parseFloat(editAddress?.region?.latitude) : tempAddress.latitude,
                      longitude: openFromEdit ? parseFloat(editAddress?.region?.longitude) : tempAddress.longitude,
                    }}
                    func={(obj) => {
                      getPlacesDetails(obj);
                    }}
                  />
                }
              </div>
            </div>
            <div className="col-12 mb-3">
              <input
                type="text"
                className="form-control"
                placeholder="Area, Colony, Street*"
                value={tempAddress.address_line2 || editAddress.address_line2}
                onChange={(e) => {
                  setTempAddress({
                    ...tempAddress,
                    address_line2: e.target.value,
                  });
                  setEditAddress({ ...editAddress, address_line2: e.target.value });
                }}
              />
              {checkValidation(tempAddress?.address_line2 || editAddress?.address_line2) ? null : (
                <p className="error">This feild is required.</p>
              )}
            </div>
            <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12 mb-3">
              <input
                type="text"
                className="form-control"
                placeholder="Building Name*"
                value={building}
                onChange={(e) => {
                  setBuilding(e.target.value);
                }}
              />
              {checkValidation(building) ? null : (
                <p className="error">Building name is required.</p>
              )}
            </div>
            <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12 mb-3">
              <input
                type="text"
                className="form-control"
                placeholder="Pincode*"
                value={
                  (tempAddress?.pincode ? tempAddress.pincode : tempAddress.zipcode || editAddress?.pincode ? editAddress.pincode : editAddress.zipcode)
                }
                onChange={(e) => {
                  setTempAddress({ ...tempAddress, pincode: e.target.value });
                  setEditAddress({ ...editAddress, pincode: e.target.value });
                }}
              />
              {checkValidation(
                tempAddress?.pincode ? tempAddress.pincode : tempAddress.zipcode || editAddress?.pincode ? editAddress.pincode : editAddress.zipcode
              ) ? null : (
                <p className="error">Pincode is required.</p>
              )}
            </div>
            <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12 mb-4">
              <input
                type="text"
                className="form-control"
                placeholder="City*"
                value={tempAddress?.city || editAddress?.city}
                onChange={(e) => {
                  setTempAddress({ ...tempAddress, city: e.target.value });
                  setEditAddress({ ...editAddress, city: e.target.value });
                }}
              />
              {checkValidation(tempAddress?.city || editAddress?.city) ? null : (
                <p className="error">City is required.</p>
              )}
            </div>
            <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12 mb-4">
              <input
                type="text"
                className="form-control"
                placeholder="State*"
                value={tempAddress?.state || editAddress?.state}
                onChange={(e) => {
                  setTempAddress({ ...tempAddress, state: e.target.value });
                  setEditAddress({ ...editAddress, state: e.target.value });
                }}
              />
              {checkValidation(
                tempAddress?.state || editAddress?.state
              ) ? null : (
                <p className="error">State is required.</p>
              )}
            </div>
            <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
            </div>
            <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
              <div className="select-location-home-office-container">
                <div className="address-type-title">Address Type</div>
                <div className="select-location-home-office-list">
                  {["HOME", "WORK", "OTHER"].map((tag) => (
                    <div
                      key={tag}
                      className={`select-location-home-office-items ${(tempAddress?.tag?.toLowerCase() === tag.toLowerCase() ||
                        editAddress?.tag?.toLowerCase() === tag.toLowerCase())
                        ? "active"
                        : ""
                        }`}
                      onClick={() => {
                        setTempAddress({ ...tempAddress, tag });
                        setEditAddress({ ...editAddress, tag });
                      }}
                    >
                      {tag.charAt(0).toUpperCase() + tag.slice(1).toLowerCase()}
                      <input
                        type="radio"
                        name="gender"
                        checked={
                          tempAddress?.tag?.toLowerCase() === tag.toLowerCase() ||
                          editAddress?.tag?.toLowerCase() === tag.toLowerCase()
                        }
                        onChange={() => {
                          setTempAddress({ ...tempAddress, tag });
                          setEditAddress({ ...editAddress, tag });
                        }}
                      />
                    </div>
                  ))}
                </div>
                {checkValidation(tempAddress?.tag || editAddress.tag) ? null : (
                  <p className="error">Please Select Tag.</p>
                )}
              </div>
            </div>
          </div>
          <button
            disabled={
              !checkValidation(buyerName) ||
              !checkValidation(buyerNumber) ||
              !checkEmailPhoneValidation("email", emailId) ||
              !checkValidation(building)
            }
            className="button-loader-bt-kl"
            type="button"
            onClick={() => {
              handleSaveAndProceed();
              setMap(false);
            }}
          >
            {openFromEdit ? "UPDATE" : "SAVE"}
            {loadingAddAddress && <LoaderWhite />}
          </button>
        </ModalBody>
      </Modal>
      {openRazorpay && (
        <Modal
          isOpen={openRazorpay}
          toggle={() => {
            setOpenRazorpay(false);
          }}
          className="custom-modal-kl"
        >
          <PreRazorpay
            orderDetails={{ ondcOrderId: ondcOrderId, userId: user?._id }}
            orderAmount={parseFloat(
              totalItemAmount + totalOtherChargesAmount - discountAmount
            )}
            setOpenRazorpay={setOpenRazorpay}
            couponId={selectedCoupon?._id}
            onPaymentResponse={handlePaymentResponse}
          />
        </Modal>
      )}
      {loadingMapAddress && (
        <div className="dotLoader">{loadingMapAddress && <Loader />}</div>
      )}
      <ThankYouModal
        orderAmount={
          discountAmount ? payableAmount - discountAmount : payableAmount
        }
        openModal={openThankPopup}
        setOpenModal={setOpenThankPopup}
        orderDetails={orderDetails}
        openErrorModal={openErrorModal}
        setOpenErrorModal={setOpenErrorModal}
        errorModalError={errorModalError}
      />
    </>
  );
};
export default Checkout;
